import React from 'react'
import { Link } from 'react-router-dom'
import PublicFooter from '../ui/PublicFooter'

const LOGIN_LOGO_URL = `${process.env.PUBLIC_URL}/logo512.png`

export default function GatewayTimeoutPage() {
    return (
        <div className="min-h-screen flex flex-col">
            <main className="flex-1 flex items-center justify-center px-4 py-12">
                <div className="w-full max-w-sm">
                    <div className="flex flex-col items-center gap-3 mb-6">
                        <div className="w-64 h-20 overflow-hidden">
                            <img
                                src={LOGIN_LOGO_URL}
                                alt="설계 EZ"
                                className="w-full h-full object-cover object-center"
                            />
                        </div>
                        <p className="text-base text-slate-600 text-center leading-snug">
                            보험 설계의 표준을 재정의하다.<br />
                            더 안전하게, 더 빠르게.
                        </p>
                    </div>
                    <div className="w-full space-y-4 p-6 border rounded-lg bg-white text-center">
                        <h1 className="text-xl font-semibold">요청 시간 초과 (504)</h1>
                        <p className="text-slate-600">요청 처리 시간이 초과되었습니다. 잠시 후 다시 시도해주세요.</p>
                        <div className="pt-2">
                            <Link className="inline-block w-full rounded bg-brand-navy text-white py-2 px-4" to="/">
                                홈으로
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
            <PublicFooter />
        </div>
    )
}
